fabric.Object.NUM_FRACTION_DIGITS = 10;

fabric.Object.prototype.objectCaching  =false
fabric.StaticCanvas.prototype.loadFromPrintDimensionsJSONForPreview = fabric.Canvas.prototype.loadFromPrintDimensionsJSONForPreview = (ratio, objects_positions, callback) ->

  data = [] 
  clone = $.extend(true, {}, objects_positions);
  
  #data = clone
  angular.forEach clone.objects, (object, index) ->
    if object.object_type != "picture_template"
      data.push(object)
  clone.objects = data
  canvas = this

  this.workWithPrintDimensions ratio, (callbackus) ->
    data2 = canvas.add_ratio_to_summary_bloc_data((1 / ratio), clone)
    canvas.loadFromJSON  data2, () ->
      callbackus()
      canvas.renderAll()
      callback() if callback
      #canvas.jqueryObject().show()
      
fabric.StaticCanvas.prototype.loadFromPrintDimensionsJSON = fabric.Canvas.prototype.loadFromPrintDimensionsJSON = (ratio, objects_positions, callback) ->
  # print page dimensions are always provided in the data
  # we save the print_page dimensions into the global variables
  #if data != undefined && data.page != undefined
  #  window.print_page_width  = data.page.print_page_width
  #  window.print_page_height = data.page.print_page_height
  # we redimension the canvas if needed
  #this.setProportionnalHeight()
  # we resize the canvas to the print page dimensions
  data = clone = $.extend(true, {}, objects_positions);
  canvas = this
  #if canvas != undefined && canvas.page != undefined && canvas.page["print_page_height"] != undefined
  #  r  = canvas.page["print_page_height"] / canvas.getHeight()
  #else if canvas != undefined
  #  r  = window.print_page_height / canvas.getHeight()
  #else 
  #  r = 1
  this.workWithPrintDimensions ratio, (callbackus) ->
    # we load data from json into the canvas
    #canvas.backgroundImage = ""
    #canvas.jqueryObject().hide()
    #if data != undefined && data.backgroundImage != undefined && data.backgroundImage != null
    #  data.backgroundImage.canvas_ratio = r
    data2 = canvas.add_ratio_to_summary_bloc_data((1 / ratio), data)
    canvas.loadFromJSON  data2, () ->
      callbackus()
      canvas.renderAll()
      callback() if callback
      #canvas.jqueryObject().show()
      

fabric.StaticCanvas.prototype.workWithPrintDimensions = fabric.Canvas.prototype.workWithPrintDimensions = (ratio, callback) ->
  #console.log "WORKING WITH PRINT DIMENSIONS---------------------"
  canvas = this
  #canvas.zoomIt (1), () ->
  callback () ->
          
fabric.StaticCanvas.prototype.workWithPrintDimensions2 = fabric.Canvas.prototype.workWithPrintDimensions2 = (ratio, callback) ->
  #console.log "WORKING WITH PRINT DIMENSIONS---------------------"
  canvas = this
  canvas.zoomIt ratio, () ->
    callback () ->
      canvas.zoomIt 1 / ratio, () ->
        console.log(1 / ratio)
          #console.log "DONE WORKING WITH PRINT DIMENSIONS---------------------"


#
fabric.StaticCanvas.prototype.zoomIt = fabric.Canvas.prototype.zoomIt = (factor, callback) ->
  #this.setHeight(this.getHeight() * factor)
  #this.setWidth(this.getWidth() * factor)
  if (this.backgroundImage)
    # Need to scale background images as well
    bi = this.backgroundImage;
    #bi.width = bi.width * factor; 
    #bi.height = bi.height * factor;
    bi.top = bi.top * factor;
    bi.left = bi.left * factor;
    bi.scaleX = bi.scaleX * factor
    bi.scaleY = bi.scaleY * factor
  objects = this.getObjects()
  for object in objects 
    #scaleX = object.scaleX
    #scaleY = object.scaleY
    #left   = object.left
    #top    = object.top
    #tempScaleX = scaleX * factor
    #tempScaleY = scaleY * factor
    #tempLeft   = left   * factor
    #tempTop    = top    * factor
    object.scaleX = object.scaleX * factor
    object.scaleY = object.scaleY * factor
    object.left   = object.left * factor
    object.top    = object.top * factor
    
    #if object.object_type == "text"
    #  object.width   = object.width * factor
    #  object.height    = object.height * factor
    if object.object_type == "picture"
      
      object.clipPath.scaleX = object.clipPath.scaleX * factor
      object.clipPath.scaleY = object.clipPath.scaleY * factor
      object.clipPath.left   = object.clipPath.left * factor
      object.clipPath.top    = object.clipPath.top * factor
    object.setCoords()
    #console.log object
  this.renderAll()
  callback()
  # console.log "ratio applied ----------------------------"
  
fabric.StaticCanvas.prototype.add_ratio_to_summary_bloc_data = fabric.Canvas.prototype.add_ratio_to_summary_bloc_data = (factor, data2) ->
  data = data2
  #data.setHeight(data.getHeight() * factor)
  #data.setWidth(data.getWidth() * factor)
  if (data.backgroundImage)
    # Need to scale background images as well
    bi = data.backgroundImage;
    #bi.width = bi.width * factor; 
    #bi.height = bi.height * factor;
    data2.backgroundImage.top = bi.top * factor;
    data2.backgroundImage.left = bi.left * factor;
    data2.backgroundImage.scaleX = bi.scaleX * factor
    data2.backgroundImage.scaleY = bi.scaleY * factor
  
  objects = data.objects
  angular.forEach objects, (object, index) -> 
    #scaleX = object.scaleX
    #scaleY = object.scaleY
    #left   = object.left
    #top    = object.top
    #tempScaleX = scaleX * factor
    #tempScaleY = scaleY * factor
    #tempLeft   = left   * factor
    #tempTop    = top    * factor
    data2.objects[index].scaleX = object.scaleX * factor
    data2.objects[index].scaleY = object.scaleY * factor
    data2.objects[index].left   = object.left * factor
    data2.objects[index].top    = object.top * factor
    
    #if object.object_type == "text"
    #  object.width   = object.width * factor
    #  object.height    = object.height * factor
    if object.object_type == "picture" && object.clipPath != undefined
      
      data2.objects[index].clipPath.scaleX = object.clipPath.scaleX * factor
      data2.objects[index].clipPath.scaleY = object.clipPath.scaleY * factor
      data2.objects[index].clipPath.left   = object.clipPath.left * factor
      data2.objects[index].clipPath.top    = object.clipPath.top * factor
    else if object.object_type == "text" || object.object_type == "text_template"
      ratioX = (data2.objects[index].scaleX / 1)
      ratioY = (data2.objects[index].scaleY / 1)
      data2.objects[index].scaleX = data2.objects[index].scaleX / ratioX
      data2.objects[index].scaleY = data2.objects[index].scaleY / ratioY
      data2.objects[index].fontSize = object.fontSize * factor# * r
      data2.objects[index].width = data2.objects[index].width * ratioX
      data2.objects[index].height = data2.objects[index].height * ratioY
  return data2
  
fabric.Canvas.prototype.selectionIsGroup = () ->
  if !this.getActiveObject()
    return false
  else
    return (this.getActiveObject().type == 'group' || (this.getActiveObject()._objects != undefined && this.getActiveObject()._objects.length > 1))

fabric.Image.fromObject = (_object, callback) ->
  object = fabric.util.object.clone(_object)
  
  if object.src != undefined
    if object.src.indexOf('akasha/note_blanc') != -1 || object.src.indexOf('default_images/note_blanc') != -1
      object.src = $("#default_note_blanc").attr('src')
    else if object.src.indexOf('akasha/note_grey') != -1 || object.src.indexOf('default_images/note_grey') != -1
      object.src = $("#default_note_grey").attr('src')
    else if object.src.indexOf('akasha/note') != -1 || object.src.indexOf('default_images/note') != -1
      object.src = $("#default_note").attr('src')

  fabric.util.loadImage object.src, ((img, isError) ->
    if isError
      callback and callback(null, true)
      return
    fabric.Image::_initFilters.call object, object.filters, (filters) ->
      object.filters = filters or []
      fabric.Image::_initFilters.call object, [ object.resizeFilter ], (resizeFilters) ->
        object.resizeFilter = resizeFilters[0]
        fabric.util.enlivenObjects [ object.clipPath ], (enlivedProps) ->
          object.clipPath = enlivedProps[0]
          image = new (fabric.Image)(img, object)
          image.perPixelTargetFind = true
          callback image, false
          return
        return
      return
    return
  ), null, "anonymous"
  return